module.exports = __webpack_public_path__ + "img/CM-NL-24-Cadillac-Playful.c8c270a5.jpg";